import type { TourStep } from './types';

export const ozonSteps: TourStep[] = [
  {
    target: 'body',
    title: 'Добро пожаловать в интеграцию Ozon',
    content: 'Здесь вы можете управлять синхронизацией товаров с маркетплейсом Ozon: загружать товары, обновлять цены и остатки, отслеживать статусы.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="ozon-sync-btn"]',
    title: 'Синхронизация с Ozon',
    content: 'Нажмите эту кнопку для загрузки актуальных данных о товарах из вашего кабинета Ozon. Процесс выполняется в фоновом режиме.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="ozon-stats"]',
    title: 'Статистика',
    content: 'Здесь отображается общая статистика по Ozon: количество товаров, активные позиции, заказы и выручка.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="ozon-products-table"]',
    title: 'Последняя активность',
    content: 'Список последних действий с товарами Ozon: синхронизации, обновления цен и остатков.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: 'body',
    title: 'Готово!',
    content: 'Теперь вы знаете основные функции интеграции с Ozon. Регулярно синхронизируйте данные для актуальности. Удачных продаж!',
    placement: 'center',
    disableBeacon: true,
  },
];
